import React from 'react';

const Nav = () => {
  return (
    <header className="header-sticky header-absolute">
      <nav className="navbar navbar-expand-xl">
        <div className="container">
          {/* Logo */}
          <a className="navbar-brand me-0" href="/">
            <img
              className="light-mode-item navbar-brand-item"
              src="img/elegant-advisors-logo.png"
              alt="logo"
            />
            <img
              className="dark-mode-item navbar-brand-item"
              src="assets/images/logo-light.svg"
              alt="logo"
            />
          </a>

          {/* Navbar Toggler */}
          <button
            className="navbar-toggler ms-sm-3 p-2"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-animation">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          {/* Navbar Links */}
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <a className="nav-link" activeStyle={{ color: 'red' }} href="/">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="about-us">About us</a>
              </li>

              {/* Services Dropdown */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="servicesDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Services
                </a>
                <div className="dropdown-menu dropdown-large p-4" aria-labelledby="servicesDropdown"
                  style={{
                    width: "max-content",
                    left: "-186px",
                    //   transform: "translateX(-50%)",
                    //   marginTop: "0.5rem",
                    //   minWidth: "80vw",
                    border: "none",
                    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
                    //   padding: "1rem",
                    backgroundColor: "#fff",
                    zIndex: 1000
                  }} >
                  <div className="row">
                    {/* Accounting */}
                    <div className="col-md-6 col-xl-4 g-0">
                      <h6 className="dropdown-header" style={{color: '#ee6523', fontSize: '18px'}}>Accounting</h6>
                      <a className="dropdown-item" href="accounting-outsourcing">Accounting Outsourcing</a>
                      <a className="dropdown-item" href="accounts-receivable-outsourcing">Accounts Receivable Outsourcing</a>
                      <a className="dropdown-item" href="accounts-payable-outsourcing">Accounts Payable Outsourcing</a>
                      <a className="dropdown-item" href="bookkeeping-outsourcing">Bookkeeping Outsourcing</a>
                      <a className="dropdown-item" href="migrating-accounting-system">Migrating Accounting System</a>
                      <br />
                                            
                      <h6 className="dropdown-header" style={{color: '#ee6523', fontSize: '18px'}}>Financial Reports</h6>
                      <a className="dropdown-item" href="financial-reports">MIS Reports</a>
                      <a className="dropdown-item" href="financial-reports">Budgeting and Forecasting</a>
                      <a className="dropdown-item" href="financial-reports">Projections</a>
                      <a className="dropdown-item" href="financial-reports">Profit & Loss AC</a>
                      <a className="dropdown-item" href="financial-reports">Balance Sheet</a>
                    </div>

                    {/* Auditing */}
                    <div className="col-md-6 col-xl-4">
                      <h6 className="dropdown-header" style={{color: '#ee6523', fontSize: '18px'}}>Auditing</h6>
                      <a className="dropdown-item" href="internal-and-external-auditing">Internal & External Auditing</a>
                      <a className="dropdown-item" href="bank-reconciliation">Bank Reconciliation</a>
                      <a className="dropdown-item" href="intercompany-reconciliation">Intercompany Reconciliation</a>
                      <a className="dropdown-item" href="inventory-audit">Inventory Audit</a>
                      <a className="dropdown-item" href="manufacturing-stock-audit">Manufacturing Stock Audit</a>
                      <a className="dropdown-item" href="pharmaceuticals-stock-audit">Pharmaceuticals Stock Audit</a>
                      <a className="dropdown-item" href="health-care-stock-audit">Health Care Stock Audit</a>
                      {/* <a className="dropdown-item" href="construction-stock-audit">Construction  Audit</a> */}
                      {/* <a className="dropdown-item" href="retail-stock-audit">Retail stock audit</a> */}

                      <a className="dropdown-item" href="construction-stores-stock-audit"> Construction stores stock audit </a>
                      <a className="dropdown-item" href="retail-stores-stock-audit"> Retail stores stock audit  </a>



                    </div>

                    <div className="col-md-6 col-xl-4">
                      <h6 className="dropdown-header" style={{color: '#ee6523', fontSize: '18px'}}> Filing Returns </h6>
                      <a className="dropdown-item" href="goods-and-services-tax-gst">Goods and Services Tax (GST)</a>
                      <a className="dropdown-item" href="tax-deducted-at-source-tds">Tax Deducted at Source (TDS)</a>
                      <a className="dropdown-item" href="pf-esic-pt">PF, ESIC & PT</a>
                      <br />
                      <h6 className="dropdown-header" style={{color: '#ee6523', fontSize: '18px'}}>HR Management</h6>
                      <a className="dropdown-item" href="payroll-management">Payroll Management</a>
                      <a className="dropdown-item" href="manpower-management">Manpower Management</a>

                      <br />
                      <h6 className="dropdown-header" style={{color: '#ee6523', fontSize: '18px'}}>Project Funding </h6>
                      <a className="dropdown-item" href="project-funding-and-business-loans">Project Funding and Business Loans</a>
                       


                    </div>


                   
                    {/* Reports */}
                    <div className="col-md-6 col-xl-4 g-0">
                      
                    </div>

                    {/* HR */}
                    <div className="col-md-6 col-xl-4">
                      
                    </div>
                  </div>
                </div>
              </li>

              {/* Software Expertise */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="softwareDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Software Expertise
                </a>
                <ul className="dropdown-menu" aria-labelledby="softwareDropdown">
                  <li><a className="dropdown-item" href="sap-accounting">SAP Accounting</a></li>
                  <li><a className="dropdown-item" href="ginesys-accounting">Ginesys Accounting</a></li>
                  <li><a className="dropdown-item" href="tally-accounting">Tally Accounting</a></li>
                  <li><a className="dropdown-item" href="opticon-accounting">OPTICON (CIVIT BUILD) Accounting</a></li>
                  <li><a className="dropdown-item" href="quickbook-accounting">QuickBooks Accounting</a></li>
                  <li><a className="dropdown-item" href="marami-accounting">Marami Accounting</a></li>
                  <li><a className="dropdown-item" href="focus-accounting">Focus Accounting</a></li>
                  <li><a className="dropdown-item" href="fusil-accounting">Fusil Accounting</a></li>
                </ul>
              </li>

              {/* Clientele */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="clienteleDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Clientele
                </a>
                <ul className="dropdown-menu" aria-labelledby="clienteleDropdown">
                  <li><a className="dropdown-item" href="constructions-and-real-estate">Constructions and Real Estate</a></li>
                  <li><a className="dropdown-item" href="textile-and-garments-industry">Textiles and Garments Industry</a></li>
                  <li><a className="dropdown-item" href="interior-design">Interior Design</a></li>
                  <li><a className="dropdown-item" href="manufacturing-services">Manufacturing </a></li>
                  <li><a className="dropdown-item" href="pharmaceuticals">Pharmaceuticals</a></li>
                  <li><a className="dropdown-item" href="healthcare">Healthcare</a></li>
                </ul>
              </li>

              {/* Other links */}
              <li className="nav-item">
                <a className="nav-link" href="careers">Careers</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="contact-us">Contact us</a>
              </li>
            </ul>

            {/* Sign In */}
            <ul className="nav align-items-center ms-sm-2">
              <li className="nav-item me-2 d-none d-sm-block">
                <a href="sign-in" className="btn btn-sm btn-light mb-0">
                  <i className="bi bi-person-circle me-1"></i>Sign in
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Nav;